<template>
  <v-card class="merchantCard" @click="$emit('click')" elevation="0" :ripple="false">
    <div class="imageArea" :style="{ backgroundImage: 'url(' + logoUrl + ')' }">
      <FavoriteChip :isFavorited="isFavorited" @favorite-clicked="$emit('favorite-toggled', $event)" />
    </div>
    <v-card-text class="detailsArea">
      <div class="merchantName">{{ merchantName }}</div>
      <div class="savingsText">Save <b>{{ savingPercentage }}%</b></div>
    </v-card-text>
  </v-card>
</template>

<script>
import FavoriteChip from './FavoriteChip.vue';

export default {
  name: 'MerchantCard',
  components: {
    FavoriteChip
  },
  props: {
    logoUrl: {
      type: String,
      required: true,
    },
    merchantName: {
      type: String,
      required: true,
    },
    savingPercentage: {
      type: Number,
      required: true,
    },
    isFavorited: {
      type: Boolean,
      default: false,
    }
  },
};
</script>

<style scoped>
.merchantCard {
  border-radius: 12px !important;
  background-color: var(--background-color-main);
}

.imageArea {
  position: relative;
  border-radius: 12px;
  height: 112px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 16px;
  background-size: cover;
  background-position: center;
}

.detailsArea {
  height: 56px;
  padding: 12px !important;
  text-align: left;
}

.merchantName {
  font-size: 15px;
  font-weight: bold;
  margin-bottom: 4px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.savingsText {
  font-size: 13px;
}
</style>
